import React, { Suspense } from "react";
import Layout from "../../layout/Layout";
import { Outlet } from "react-router-dom";
import logo from "../../assets/images/tutify-logo-dark.png";

const Fallback = () => {
  return (
    <div
      style={{
        display: "grid",
        placeItems: "center",
        backgroundColor: "#f2f3f9",
        minHeight: "100vh",
      }}
    >
      <img style={{ height: "32px" }} src={logo} alt="Tutify Logo" />
    </div>
  );
};

const SplashScreen = () => {
  return (
    <Suspense fallback={<Fallback />}>
      <Layout>
        <Outlet />
      </Layout>
    </Suspense>
  );
};

export default SplashScreen;
